interface SharePanelProps {
  open: boolean;
  title: string;
  onClose: () => void;
  onShare: (platform: string) => void;
}

const platformList = [
  { key: "微博", icon: "ri-weibo-fill" },
  { key: "微信", icon: "ri-wechat-fill" },
  { key: "QQ", icon: "ri-qq-fill" },
  { key: "复制链接", icon: "ri-link" },
];

export default function SharePanel({ open, title, onClose, onShare }: SharePanelProps) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60] flex items-end justify-center bg-background-50/85 px-4 pb-6 backdrop-blur-sm sm:items-center sm:pb-0">
      <div
        className="absolute inset-0"
        onClick={onClose}
        role="presentation"
      />
      <div className="relative z-10 w-full max-w-sm animate-fade-up rounded-lg border border-background-300/60 bg-background-100 p-6">
        <div className="flex items-start justify-between">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-50">分享给朋友</h3>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{title}</p>
          </div>
          <button
            type="button"
            aria-label="关闭"
            onClick={onClose}
            className="flex h-8 w-8 items-center justify-center rounded-md text-foreground-400 transition-colors hover:bg-background-200/60 hover:text-foreground-50"
          >
            <i className="ri-close-line text-xl" />
          </button>
        </div>

        <div className="mt-6 grid grid-cols-4 gap-3">
          {platformList.map((platform) => (
            <button
              key={platform.key}
              type="button"
              onClick={() => onShare(platform.key)}
              className="flex flex-col items-center gap-2 rounded-lg p-2 transition-colors hover:bg-background-200/50"
            >
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-primary-100 text-primary-400">
                <i className={`${platform.icon} text-xl`} />
              </span>
              <span className="text-xs text-foreground-300">{platform.key}</span>
            </button>
          ))}
        </div>

        <p className="mt-6 rounded-md bg-background-200/50 px-3 py-2 text-xs leading-relaxed text-foreground-500">
          本站为演示站点，分享功能会将当前页面链接复制到剪贴板，方便你在社交平台粘贴分享。
        </p>
      </div>
    </div>
  );
}